import React, { useState, useEffect } from 'react'
import { DappMenuSreen } from '../UI/DappMenuSreen'

import Avatar from '@mui/material/Avatar';


import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import ButtonGroup from '@mui/material/ButtonGroup';
import { useForm } from '../../hooks/useForm';
import moment from 'moment';

import TextField from '@mui/material/TextField';
import { app, db, storage } from "../../firebaseConfig/firebaseConfig";
import { getFirestore, collection, getDocs, setDoc, addDoc, doc, getDoc,query, where,updateDoc, orderBy } from 'firebase/firestore/lite';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { Player, Controls } from '@lottiefiles/react-lottie-player';

import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import AvatarGroup from '@mui/material/AvatarGroup';

import Chip from '@mui/material/Chip';

import DoneIcon from '@mui/icons-material/Done';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { useHistory } from 'react-router';


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));




export const DappMyContrats = () => {

    const history = useHistory();
    const [contacts, setcontacts] = useState([]);
    const [viewcontacts, setviewcontacts] = useState([]);

    const [category, setcategory]=useState('agente')

    const myuser =  localStorage.getItem("email");

    const [open, setOpen] = useState(false);
    const [find, setFind] = useState(null);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);

      setFind(null);
    };



    const getInfo = async () => {
        try {
            console.log("aqui", myuser)
            console.log(myuser);
            console.log("em"+category, myuser,"yoooo");
            let red = localStorage.getItem("red");
            const userref = doc(db, "users", localStorage.getItem("uid"));
            const walletdata = {
                wallet: localStorage.getItem("wallet"),
            }
            const resultuser = await getDoc(userref);
            if(resultuser.data().wallet == undefined || resultuser.data().wallet == null){ 
            await updateDoc(userref, walletdata);
            console.log("no lo va a hacer")
            }
            const q = query(collection(db, "contracts"), where("em"+category, "==", myuser ), where("red","==",red) );
            const querySnapshot = await getDocs(q);
            let info = [];
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                let data = doc.data();
                console.log(doc.data());
                data["id"] = doc.id;
                info.push(JSON.stringify(data));
    
            });
    
            console.log(info)
    
            if( info.length > 0){
                console.log("entra?")
                await setcontacts("show");
                await setviewcontacts(info);
            }
            
        } catch (error) {
            console.log(error);
            
        }
     


        
    }



    const changeCategory = async(e) => {
        console.log(e.target.textContent)
        if(e.target.textContent == "agente"){
            console.log("agente entra")
            await setcategory("agente");
        }else if(e.target.textContent== "depositante"){

            await setcategory("depositante");
        }else if(e.target.textContent == "depositario"){

            await setcategory("depositario");
        }
        setcontacts([]);
        
    }
    


    const goToDetails = async (id) => {
        console.log(id,"hey");
        history.push(`/dapp/contract/${id}`);
    }


    useEffect(() => {
        getInfo();
      
    }, [category])



    const action = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClose}>
            
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );


    return (
        <div>
            <div className="dapp_container2">
                <DappMenuSreen />

                

                <h4 style={{ marginTop: "130px", textAlign: "center", fontSize: "28px" }}>Mis contratos </h4>

                <ButtonGroup onClick={((e) => changeCategory(e))} className="dapp__buttongroup" variant="outlined" aria-label="outlined button group">
  <Button className={`${category == 'agente' ? 'dapp__active' : ''}`}     >agente</Button>
  <Button className={`${category == 'depositante' ? 'dapp__active' : ''}`}   >depositante</Button>
  <Button className={`${category == 'depositario' ? 'dapp__active' : ''}`}   >depositario</Button>
</ButtonGroup>
              
{contacts.length == 0  && 
<div className="dapp_container2">
                <Player
                        className="dapp__lottie"
                        autoplay
                        loop
                        src="../assets/gifts/36634-loading-experiments.json"
                    >
                    </Player>
                    <h3>Aún no tienes contratos de tipo {category}</h3>
                  
                    </div>

}
{contacts.length > 0 &&
             <div className="dapp__contacts">
               
                <Box sx={{ flexGrow: 1 }}>
      <Grid  container spacing={{ xs: 2, md: 3 }} columns={{ xs: 2, sm: 8, md: 12 }}>
        {Array.from(viewcontacts).map((_, index) => (
          <Grid onClick={() => goToDetails((JSON.parse(viewcontacts[index])).id)} item xs={2} sm={4} md={4} key={index}>
            <Item>
            <h2>{(JSON.parse(viewcontacts[index])).name} </h2>  
            <AvatarGroup className="dapp__avatar2" max={3}>
                <Avatar alt={(JSON.parse(viewcontacts[index]))?.emagente } src={(JSON.parse(viewcontacts[index]))?.imgagente} />
                <Avatar alt={(JSON.parse(viewcontacts[index]))?.emdepositante }  src={(JSON.parse(viewcontacts[index]))?.imgdepositante} />
                <Avatar alt={(JSON.parse(viewcontacts[index]))?.emdepositario }  src={(JSON.parse(viewcontacts[index]))?.imgdepositario} />
            </AvatarGroup>

            {JSON.parse(viewcontacts[index]).validate == undefined  && 
            <Chip color="primary" label="Creado" icon={<HourglassEmptyIcon />} />
            }
            {(JSON.parse(viewcontacts[index]).validate && JSON.parse(viewcontacts[index]).movimientos == undefined) == true && 
            <Chip color="success" label="Validado" icon={<DoneOutlineIcon />} />
            }

{(JSON.parse(viewcontacts[index]).validate && JSON.parse(viewcontacts[index]).movimientos != undefined) == true && 
            <Chip color="secondary" label="Con transacciones" icon={<ReceiptLongIcon />} />
            }
             
              <p className="dapp__contdescription">{(JSON.parse(viewcontacts[index])).description}</p>


    <p>Fecha de creación: {moment((JSON.parse(viewcontacts[index])?.create.seconds)*1000).format("DD-MM-YYYY HH:mm ")}</p>
                </Item>
          </Grid>
        ))}
      </Grid>
    </Box>
    </div>
    }


            </div>
        </div>
    )
}
